<template>
  <div id="nav-footer">
    <div id="nav-footer-root">
      <BaseFooter v-bind="attrs" />
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, computed } from 'vue';

import { useInitFooter } from '~/composables/useInit';
import { GET_ATTRS } from '#shared/types/getters';
import BaseFooter from './BaseFooter';
import { IS_STATE_RESTORATION_FROM_DOM_ENABLED, restoreFooterLinks } from '~/utils/restoreStateFromDom';
import { isSSR } from '#shared/utils/isSSR';

const navHeader = useNavHeader();
const navFooter = useNavFooter();
const { isNavSSR } = useEnvProps();
const attrs = computed(() => navHeader[GET_ATTRS]);
const isMinimal = attrs.value.isMinimal ?? false;

if (!isMinimal && !isSSR()) {
  useInitFooter();
}

onBeforeMount(() => {
  // only run menu restoration for SSR pages
  if (isNavSSR && IS_STATE_RESTORATION_FROM_DOM_ENABLED && !isMinimal) {
    const performanceTimerName = '[navigation-wgl] footer parse time';
    console.time(performanceTimerName);
    const { footerLinks, legalLinks } = restoreFooterLinks();
    navFooter.data.footer.footerLinks = footerLinks;
    navFooter.data.footer.legalLinks = legalLinks;
    console.timeEnd(performanceTimerName);
  }
});
</script>

<style lang="scss">
@import '~/assets/scss/common/reset.scss';
</style>
